// src/app/customization/page.jsx
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../../components/ui/card";
import { Sparkles } from "lucide-react";

export default function CustomizationPage() {
  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center">
              <Sparkles className="h-8 w-8 text-primary-foreground" />
            </div>
          </div>
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Customization Studio
          </h1>
          <p className="text-xl text-muted-foreground">
            Personalize every detail of your event products
          </p>
        </div>
        <Card className="backdrop-blur-sm bg-card/70 border-2 border-border">
          <CardHeader>
            <CardTitle>Coming Soon</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              Our customization studio is under development. Soon you'll be able to personalize colors, scents, sizes, and more!
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
